module.exports = __webpack_public_path__ + "static/img/rank_328.43646e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_328.png
// module id = GxDf
// module chunks = 0